/**
 * Module: lib/telemetry/toolDecision
 * Fire-and-forget logging for destructive-tool confirm/reject decisions.
 * V1: console log + Sentry breadcrumb (if Sentry SDK is present globally).
 * Subsystem 3 extends this to persist to the copilot_usage table.
 */

export function recordToolDecision(tool: string, decision: 'approve' | 'reject'): void {
  try {
    // eslint-disable-next-line no-console
    console.info('[copilot] tool decision', { tool, decision })
    const s = (window as unknown as { Sentry?: { addBreadcrumb: (b: unknown) => void } }).Sentry
    s?.addBreadcrumb({ category: 'copilot', message: `${tool} ${decision}` })
  } catch {
    // never throw from telemetry
  }
}
